import React from "react"
import {
  Text,
  Button,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverProps,
  PopoverTrigger,
} from "@chakra-ui/react"

interface Props extends PopoverProps {
  header?: string
  text?: string
  onSubmit: () => void
  onSubmitText?: string
  children?: React.ReactNode
}

export const Confirmation: React.FC<Props> = (props) => {
  return (
    <Popover {...props}>
      <PopoverTrigger>{props.children}</PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader fontWeight="bold" textAlign="left">
          {props.header ? props.header : "Are you sure?"}
        </PopoverHeader>
        <PopoverBody>
          {props.text && <Text>{props.text}</Text>}
          <Flex justify="flex-end">
            <Button colorScheme="red" onClick={props.onSubmit}>
              {props.onSubmitText ? props.onSubmitText : "Delete"}
            </Button>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
